import { RpcError } from "grpc-web";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";
import { IncrementEnterpriseMasteringCountRequest, IncrementEnterpriseMasteringCountResponse } from "../proto/api_pb";

export const incrementMasteringCount = async (
    token: string,
    enterpriseId: string,
    userId: string
): Promise<RpcError | IncrementEnterpriseMasteringCountResponse | undefined> => {
    try {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new IncrementEnterpriseMasteringCountRequest();
        request.setEnterpriseId(enterpriseId)
        request.setUserId(userId)
        const metadata = {
            Authorization: `${token}`,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<IncrementEnterpriseMasteringCountResponse | RpcError>((resolve, reject) => {
                    ommuseClient.incrementEnterpriseMasteringCount(request, metadata, function (err, response) {
                        if (err) {
                            reject(err);
                        } else {
                            resolve(response);
                        }
                    });
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    } catch (e) {
        console.log(e);
    }
};
